import React, { useState } from 'react';
import {
	Box,
	Container,
	Grid,
	makeStyles,
	withStyles,
	FormControlLabel,
	Checkbox,
	Divider,
	useTheme,
	useMediaQuery
} from '@material-ui/core';
import TitleText from '../../components/reusableComponents/TitleText';
import BodyText from '../../components/reusableComponents/BodyText';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { toggleGSTModal, toggleTermModal } from '../../reducers/UiReducer';
import { useDispatch } from 'react-redux';
import AddGSTModal from '../../components/reusableComponents/AddGSTModal';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import TermConditionModal from '../../components/reusableComponents/TermConditionModal';
import FlightConfirmForm from '../../form/FlightConfirmForm';
import Drawers from '../../components/Drawers';
import Login from '../../components/reusableComponents/Login';
import HeaderSection from '../../components/reusableComponents/HeaderSection';
import ErrorModal from '../../components/reusableComponents/ErrorModal';
import SelectedOnwardEtravRow from '../../components/reusableComponents/SelectedOnwardEtravRow';
import SelectedReturnEtravRow from '../../components/reusableComponents/SelectedReturnEtravRow';
import SelectedOnwardTboRow from '../../components/reusableComponents/SelectedOnwardTboRow';
import FlightConfirmReturnForm from '../../form/FlightConfirmReturnForm';
const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiChip-sizeSmall': {
			height: 36,
		},
	},
	accodin: {
		'& .MuiAccordionSummary-content': {
			justifyContent: 'space-between',
		},
	},
}));
const GreenCheckbox = withStyles({
	root: {
		color: '#39c9bb',
		'&$checked': {
			color: '#39c9bb',
		},
	},
	checked: {},
})((props) => <Checkbox color='default' {...props} />);
const ConfirmFlight = () => {
	const classes = useStyles();
	const [value, setValue] = React.useState('');
	const [val, setVal] = React.useState(false);
	const [b, setB] = React.useState(false);
	const { etravflightFare } = useSelector((state) => state.ui);
	const location = useLocation();
	const dispatch = useDispatch();
	const theme = useTheme()
	const matches = useMediaQuery(theme.breakpoints.down('xs'));
	const handleChange = (event) => {
		setValue(event.target.value);
	};
	const {
		baggage,
		baggageAdult2,
		baggageAdult3,
		baggageAdult4,
		baggageAdult5,
		baggageAdult6,
		baggageAdult7,
		baggageAdult8,
		baggageAdult9,
		baggageChild1,
		baggageChild2,
		baggageChild3,
		baggageChild4,
		baggageChild5,
		baggageChild6,
		baggageChild7,
		baggageChild8,
		baggageChild9,
	} = useSelector((state) => state.ui);
	const [check, setCheck] = useState(false);
	const handleCheck = (event) => {
		// if (gst) {
		dispatch(toggleTermModal(true));
		// }

		// setCheck(event.target.checked);
	};
	function timeConvert(n) {
		var num = n;
		var hours = num / 60;
		var rhours = Math.floor(hours);
		var minutes = (hours - rhours) * 60;
		var rminutes = Math.round(minutes);
		return rhours + ' hr and ' + rminutes + ' min.';
	}
	console.log("Loc",location)
	function convertH2M(timeInHour) {
		console.log(timeInHour);
		var timeParts = timeInHour.split(':');
		return Number(timeParts[0]) * 60 + Number(timeParts[1]);
	}
// 	let etrav2 =
//     location.state.selectedonward[0].Airline_Code &&
//     location.state.selectedReturn[0].Airline_Code;
//   let etrvotbor =
//     location.state.selectedonward[0].Airline_Code &&
//     location.state.selectedReturn[0].AirlineCode;
//   let etravrtboo =
//     location.state.selectedReturn[0].Airline_Code &&
//     location.state.selectedonward[0].AirlineCode;
//   let tbo2 =
//     location.state.selectedonward[0].AirlineCode &&
//     location.state.selectedReturn[0].AirlineCode;
// 	console.log(location);
	const handleClick = (event) => {
		if (event.target.value === value) {
			setValue('');
		} else {
			setValue(event.target.value);
		}
	};
	return (
		<>
			<Box
				style={{
					paddingTop: '10px',
					// background: 'white',
					position: 'absolute',
					zIndex: 99,
					height: 60,
					top: 0,
					right: 0,
					bottom: 0,
					left: 0,
				}}>
				<Container>
					<HeaderSection id={1} />
				</Container>
			</Box>
			<Box
				style={{
					backgroundColor: '#515b62',
					marginTop: 75,
					color: 'white',
					padding: 10,
				}}>
				<Container>
					{/* <Box display='flex'>
						<TitleText three>MusafirBazar Holiday /</TitleText>
						<TitleText three textStyle={{ marginLeft: 5 }}>
							Flight / Confirm
						</TitleText>
					</Box> */}
				</Container>
			</Box>
			<Box style={{ background: "#e5eef4",paddingLeft:30,paddingRight:30 }}>
				{/* <Container> */}
					<Grid container spacing={2}>
						<Grid item xs={12} lg={8}>
							<Box display='flex' justifyContent='space-between' mt={'30px'}>
								<Box>
									<TitleText
										four
										textStyle={{
											fontFamily: 'Josefin Sans, sans-serif',
											fontWeight: 500,
											fontSize: 22,
										}}>
										Confirm Your Booking
									</TitleText>
								</Box>
							</Box>
							<Box
              style={{
                padding: 15,
                background: "white",
                color: "gray",
                border: "1px solid #e6e6e6",
                margin: "0 0 20px",
                boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                borderRadius: "5px",
              }}
            >
              {location.state.OneflightData
                ? location.state.OneflightData.Airline_Code
                  ? location.state.OneflightData.Segments.map((i, index) => {
                      return (
                        <>
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            mt={index > 0 ? "20px" : ""}
                          >
                            <Box display="flex" alignItems="center">
                              <Box alignItems="center" display="flex">
                                <TitleText
                                  textStyle={{
                                    fontFamily: "unset",
                                    fontWeight: 500,
                                    fontSize: 18,
                                  }}
                                >
                                  {location.state.OneflightData.Origin}
                                </TitleText>
                                -
                                <TitleText
                                  textStyle={{
                                    fontFamily: "unset",
                                    fontWeight: 500,
                                    fontSize: 18,
                                  }}
                                >
                                  {location.state.OneflightData.Destination}
                                </TitleText>
                              </Box>
                              <Box
                                ml={"30px"}
                                style={{
                                  background: "rgb(239, 51, 57)",
                                  padding: "3px 15px",
                                  borderRadius: "50px",
                                  color: "white",
                                  fontFamily: "unset",
                                  fontWeight: 500,
                                }}
                              >
                                <TitleText two>ONWARD</TitleText>
                              </Box>
                            </Box>
                            <Box>{/* <BodyText>Fare Rule</BodyText> */}</Box>
                          </Box>
                          <Box mt={"20px"}>
                            <BodyText three textStyle={{ fontSize: 16 }}>
                              {" "}
                              {`${new Date(
                                location.state.body.Segments[0].PreferredDepartureTime
                              ).toLocaleString("en-us", {
                                weekday: "short",
                              })} ,  ${new Date(
                                location.state.body.Segments[0].PreferredDepartureTime
                              ).getDate()} ${new Date(
                                location.state.body.Segments[0].PreferredDepartureTime
                              ).toLocaleString("en-us", {
                                month: "short",
                              })},2022`}
                            </BodyText>
                          </Box>
                          <Box
                            style={{
                              background: "white",
                              padding: "10px 15px",
                              border: "1px solid #e6e6e6",
                              marginTop: "10px",
                              borderRadius: 5,
                            }}
                          >
                            <Grid container style={{ alignItems: "center" }}>
                              <Grid item xs={12} sm={3} lg={3}>
                                <Box display={matches?'flex':''} justifyContent={matches?'space-between':''} alignItems={matches?'center':''}>
                                  <TitleText
                                    textStyle={{
                                      fontFamily: "unset",
                                      fontWeight: 500,
                                      fontSize: 18,
                                    }}
                                  >
                                    {i.Origin_City}
                                    {/* {i.Origin.Airport.AirportCode}) */}
                                  </TitleText>
                                  <TitleText
                                    three
                                    textStyle={{
                                      fontFamily: "unset",
                                      fontWeight: 600,
									  fontSize:matches?16:''
                                    }}
                                  >
                                    {i.Departure_DateTime.substr(11, 5)}
                                  </TitleText>
                                </Box>
								
                              </Grid>
                              <Grid item xs={12} sm={3} lg={3} style={{marginTop:matches?10:''}}>
                                <Box
                                  style={{
                                    padding: "2px 20px",
                                    background: "rgb(239, 51, 57)",
                                    color: "white",
                                    borderRadius: 25,
                                  }}
                                >
                                  <BodyText
                                    three
                                    textStyle={{
                                      fontSize: 16,
                                      textAlign: "center",
									  whiteSpace: "nowrap",
    overflow: 'hidden',
    textOverflow: 'ellipsis'
                                    }}
                                  >
                                    {timeConvert(convertH2M(i.Duration))}
                                  </BodyText>
                                </Box>
                              </Grid>
                              <Grid item xs={12} sm={3} lg={3} style={{ textAlign: "center",marginTop:matches?10:'' }}>
                                <Box display={matches?'flex':''} justifyContent={matches?'space-between':''} alignItems={matches?'center':''}>
                                  <TitleText
                                    textStyle={{
                                      fontFamily: "unset",
                                      fontWeight: 500,
                                      fontSize: 18,
                                    }}
                                  >
                                    {i.Destination_City}
                                    {/* {i.Origin.Airport.AirportCode}) */}
                                  </TitleText>
                                  <TitleText
                                    three
                                    textStyle={{
                                      fontFamily: "unset",
                                      fontWeight: 600,
									  fontSize:matches?16:''
                                    }}
                                  >
                                    {i.Arrival_DateTime.substr(11, 5)}
                                  </TitleText>
                                </Box>
                              </Grid>
							  <Grid item xs={12} sm={3} lg={3} style={{ textAlign: "center" }}>
							  <img
                                  src={`https://nitish.musafirbazar.com/static/media/${i.Airline_Code}.gif`}
                                  width="100px"
                                  height="80px"
                                ></img>
								<p>{`${i.Airline_Name} (${i.Airline_Code}-${i.Flight_Number})`}</p>
							  </Grid>
                            </Grid>
							
                            {/* <Grid item xs={12} sm={3} lg={3}>
                              <Box textAlign="center" display='flex'>
                                <img
                                  src={`https://nitish.musafirbazar.com/static/media/${i.Airline_Code}.gif`}
                                  width="50px"
                                  height="25px"
                                ></img>
                                <BodyText three textStyle={{ fontSize: 16 }}>
                                  {i.Airline_Name}
                                </BodyText>
                                <BodyText three textStyle={{ fontSize: 16 }}>
                                  {i.Airline_Code}-{i.Flight_Number}| Economy
                                </BodyText>
                                <BodyText three textStyle={{ fontSize: 16 }}>
                                  Check-In : 1Pc - 15Kgs
                                </BodyText>
                                <BodyText three textStyle={{ fontSize: 16 }}>
                                  Cabin : 7Kgs
                                </BodyText>
                              </Box>
                            </Grid> */}
                          </Box>
                        </>
                      );
                    })
                  : location.state.OneflightData.Segments[0].map((i, index) => {
                      return (
                        <>
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            mt={index > 0 ? "20px" : ""}
                          >
                            <Box display="flex" alignItems="center">
                              <Box alignItems="center" display="flex">
                                <TitleText
                                  textStyle={{
                                    fontFamily: "unset",
                                    fontWeight: 500,
                                    fontSize: 18,
                                  }}
                                >
                                  {i.Origin.Airport.CityCode}
                                </TitleText>
                                -
                                <TitleText
                                  textStyle={{
                                    fontFamily: "unset",
                                    fontWeight: 500,
                                    fontSize: 18,
                                  }}
                                >
                                  {index == 0
                                    ? location.state.OneflightData.Segments[0]
                                        .filter((i, ind) => ind === 0)
                                        .map((one) => {
                                          return one.Destination.Airport
                                            .CityCode;
                                        })
                                    : index == 1
                                    ? location.state.OneflightData.Segments[0]
                                        .filter((i, ind) => ind === 1)
                                        .map((one) => {
                                          return one.Destination.Airport
                                            .CityCode;
                                        })
                                    : index == 2
                                    ? location.state.OneflightData.Segments[0]
                                        .filter((i, ind) => ind === 2)
                                        .map((one) => {
                                          return one.Destination.Airport
                                            .CityCode;
                                        })
                                    : ""}
                                </TitleText>
                              </Box>
                              <Box
                                ml={"30px"}
                                style={{
                                  background: "rgb(239, 51, 57)",
                                  padding: "3px 15px",
                                  borderRadius: "50px",
                                  color: "white",
                                  fontFamily: "unset",
                                  fontWeight: 500,
                                }}
                              >
                                <TitleText two>ONWARD</TitleText>
                              </Box>
                            </Box>
                            <Box>{/* <BodyText>Fare Rule</BodyText> */}</Box>
                          </Box>
                          <Box mt={"20px"}>
						  <BodyText three textStyle={{ fontSize: 16 }}>
                              {" "}
                              {`${new Date(
                                location.state.body.Segments[0].PreferredDepartureTime
                              ).toLocaleString("en-us", {
                                weekday: "short",
                              })} ,  ${new Date(
                                location.state.body.Segments[0].PreferredDepartureTime
                              ).getDate()} ${new Date(
                                location.state.body.Segments[0].PreferredDepartureTime
                              ).toLocaleString("en-us", {
                                month: "short",
                              })},2022`}
                            </BodyText>
                          </Box>
                          <Box
                            style={{
                              background: "white",
                              padding: "10px 15px",
                              border: "1px solid #e6e6e6",
                              marginTop: "10px",
                              borderRadius: 5,
                            }}
                          >
							  <Grid container style={{ alignItems: "center" }}>
                              <Grid item xs={12} sm={3} lg={3}>
                                <Box display={matches?'flex':''} justifyContent={matches?'space-between':''} alignItems={matches?'center':''}>
                                  <TitleText
                                    textStyle={{
                                      fontFamily: "unset",
                                      fontWeight: 500,
                                      fontSize: 18,
                                    }}
                                  >
                                    {i.Origin.Airport.CityName}
                                    {/* {i.Origin.Airport.AirportCode}) */}
                                  </TitleText>
                                  <TitleText
                                    three
                                    textStyle={{
                                      fontFamily: "unset",
                                      fontWeight: 600,
									  fontSize:matches?16:''
                                    }}
                                  >
                                    {i.Origin.DepTime.substr(11, 5)}
                                  </TitleText>
                                </Box>
								
                              </Grid>
                              <Grid item xs={12} sm={3} lg={3} style={{marginTop:matches?10:''}}>
                                <Box
                                  style={{
                                    padding: "2px 20px",
                                    background: "rgb(239, 51, 57)",
                                    color: "white",
                                    borderRadius: 25,
                                  }}
                                >
                                  <BodyText
                                    three
                                    textStyle={{
                                      fontSize: 16,
                                      textAlign: "center",
									  whiteSpace: "nowrap",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
                                    }}
                                  >
                                    {timeConvert(i.Duration)}
                                  </BodyText>
                                </Box>
                              </Grid>
                              <Grid item xs={12} sm={3} lg={3} style={{ textAlign: "center",marginTop:matches?10:'' }}>
                                <Box display={matches?'flex':''} justifyContent={matches?'space-between':''} alignItems={matches?'center':''}>
                                  <TitleText
                                    textStyle={{
                                      fontFamily: "unset",
                                      fontWeight: 500,
                                      fontSize: 18,
                                    }}
                                  >{i.Destination.Airport.CityName}
                                    {/* {i.Destination_City} */}
                                    {/* {i.Origin.Airport.AirportCode}) */}
                                  </TitleText>
                                  <TitleText
                                    three
                                    textStyle={{
                                      fontFamily: "unset",
                                      fontWeight: 500,
									  fontSize:matches?16:''
                                    }}
                                  >
                                    {i.Destination.ArrTime.substr(11, 5)}
                                  </TitleText>
                                </Box>
                              </Grid>
							  <Grid item xs={12} sm={3} lg={3} style={{ textAlign: "center" }}>
							  <img
                                    src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
                                    width="50px"
                                    height="25px"
                                  ></img>
								<p>{`${i.Airline.AirlineName} (${i.Airline.AirlineCode}-${i.Airline.FlightNumber})`}</p>
							  </Grid>
                            </Grid>
                            {/* <Grid container>
                              <Grid item xs={12} sm={9} lg={9}>
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <Box>
                                    <TitleText
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                        fontSize: 18,
                                      }}
                                    >
                                      {i.Origin.Airport.CityName}(
                                      {i.Origin.Airport.AirportCode})
                                    </TitleText>
                                    <BodyText
                                      four
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {i.Origin.Airport.AirportName}
                                    </BodyText>
                                  </Box>
                                  <Box>
                                    <TitleText
                                      four
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {i.Origin.DepTime.substr(11, 5)}
                                    </TitleText>
                                  </Box>
                                </Box>
                                <Grid container alignItems="center">
                                  <Grid item xs={6} lg={9}>
                                    <Divider />
                                  </Grid>
                                  <Grid item xs={4} lg={3}>
                                    <Box
                                      style={{
                                        padding: "2px 20px",
                                        background: "rgb(239, 51, 57)",
                                        color: "white",
                                        borderRadius: 5,
                                      }}
                                    >
                                      <BodyText three>
                                        {timeConvert(i.Duration)}
                                      </BodyText>
                                    </Box>
                                  </Grid>
                                </Grid>

                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <Box>
                                    <TitleText
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                        fontSize: 18,
                                      }}
                                    >
                                      {i.Destination.Airport.CityName}(
                                      {i.Destination.Airport.AirportCode})
                                    </TitleText>
                                    <BodyText
                                      four
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {i.Destination.Airport.AirportName}
                                    </BodyText>
                                  </Box>
                                  <Box>
                                    <TitleText
                                      four
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {i.Destination.ArrTime.substr(11, 5)}
                                    </TitleText>
                                  </Box>
                                </Box>
                              </Grid>
                              <Grid item xs={12} sm={3} lg={3}>
                                <Box textAlign="center">
                                  <img
                                    src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
                                    width="50px"
                                    height="25px"
                                  ></img>
                                  <BodyText three>
                                    {i.Airline.AirlineName}
                                  </BodyText>
                                  <BodyText three>
                                    {i.Airline.AirlineCode}-
                                    {i.Airline.FlightNumber}| Economy
                                  </BodyText>
                                  <BodyText three>
                                    Check-In : 1Pc - 15Kgs
                                  </BodyText>
                                  <BodyText three>Cabin : 7Kgs</BodyText>
                                </Box>
                              </Grid>
                            </Grid> */}
                          </Box>
                        </>
                      );
                    })
                : ""}
            
              {location.state.selectedonward
                ? location.state.selectedonward[0].Airline_Code
                  ? location.state.selectedonward[0].Segments.map(
                      (i, index) => {
                        return <SelectedOnwardEtravRow i={i} index={index} />;
                      }
                    )
                  : location.state.selectedonward[0].AirlineCode
                  ? location.state.selectedonward[0].Segments[0].map(
                      (i, index) => {
                        return (
                          <SelectedOnwardTboRow
                            i={i}
                            index={index}
                            selectedonward={location.state.selectedonward}
                          />
                        );
                      }
                    )
                  : ""
                : ""}
                {location.state.intFlight
                ? location.state.intFlight.Segments[0].map((i,index) => {
                    return (
                      <>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        mt={index > 0 ? "20px" : ""}
                      >
                        <Box display="flex" alignItems="center">
                        <Box alignItems="center" display="flex">
                          <TitleText
                          textStyle={{
                            fontFamily: "unset",
                            fontWeight: 500,
                            fontSize: 18,
                          }}
                          >
                          {i.Origin.Airport.CityCode}
                          </TitleText>
                          -
                          <TitleText
                          textStyle={{
                            fontFamily: "unset",
                            fontWeight: 500,
                            fontSize: 18,
                          }}
                          >
                          {i.Destination.Airport.CityCode}
                          </TitleText>
                        </Box>
                        {index===0?<Box
                                ml={"30px"}
                                style={{
                                  background: "rgb(239, 51, 57)",
                                  padding: "3px 15px",
                                  borderRadius: "50px",
                                  color: "white",
                                  fontFamily: "unset",
                                  fontWeight: 500,
                                }}
                              >
                                <TitleText two>ONWARD</TitleText>
                              </Box>:''}
                        </Box>
                        <Box>{/* <BodyText>Fare Rule</BodyText> */}</Box>
                      </Box>
                      <Box mt={"20px"}>
                        <BodyText three textStyle={{ fontSize: 16 }}>
                        {" "}
                        {`${new Date(
                          location.state.returnBody.Segments[0].PreferredDepartureTime
                        ).toLocaleString("en-us", {
                          weekday: "short",
                        })} ,  ${new Date(
                          location.state.returnBody.Segments[0].PreferredDepartureTime
                        ).getDate()} ${new Date(
                          location.state.returnBody.Segments[0].PreferredDepartureTime
                        ).toLocaleString("en-us", {
                          month: "short",
                        })},2022`}
                        </BodyText>
                      </Box>
                      <Box
                        style={{
                        background: "white",
                        padding: "10px 15px",
                        border: "1px solid #e6e6e6",
                        marginTop: "10px",
                        borderRadius: 5,
                        }}
                      >
                        <Grid container style={{ alignItems: "center" }}>
                        <Grid item xs={12} sm={3} lg={3}>
                          <Box
                          display={matches ? "flex" : ""}
                          justifyContent={
                            matches ? "space-between" : ""
                          }
                          alignItems={matches ? "center" : ""}
                          >
                          <TitleText
                            textStyle={{
                            fontFamily: "unset",
                            fontWeight: 500,
                            fontSize: 18,
                            }}
                          >
                            {i.Origin.Airport.CityName}
                            {/* {i.Origin.Airport.AirportCode}) */}
                          </TitleText>
                          <TitleText
                            three
                            textStyle={{
                            fontFamily: "unset",
                            fontWeight: 600,
                            fontSize: matches ? 16 : "",
                            }}
                          >
                            {i.Origin.DepTime.substr(11, 5)}
                          </TitleText>
                          </Box>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={3}
                          lg={3}
                          style={{ marginTop: matches ? 10 : "" }}
                        >
                          <Box
                          style={{
                            padding: "2px 20px",
                            background: "rgb(239, 51, 57)",
                            color: "white",
                            borderRadius: 25,
                          }}
                          >
                          <BodyText
                            three
                            textStyle={{
                            fontSize: 16,
                            textAlign: "center",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            }}
                          >
                            {timeConvert(i.Duration)}
                          </BodyText>
                          </Box>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={3}
                          lg={3}
                          style={{
                          textAlign: "center",
                          marginTop: matches ? 10 : "",
                          }}
                        >
                          <Box
                          display={matches ? "flex" : ""}
                          justifyContent={
                            matches ? "space-between" : ""
                          }
                          alignItems={matches ? "center" : ""}
                          >
                          <TitleText
                            textStyle={{
                            fontFamily: "unset",
                            fontWeight: 500,
                            fontSize: 18,
                            }}
                          >
                            {i.Destination.Airport.CityName}
                            {/* {i.Destination_City} */}
                            {/* {i.Origin.Airport.AirportCode}) */}
                          </TitleText>
                          <TitleText
                            three
                            textStyle={{
                            fontFamily: "unset",
                            fontWeight: 500,
                            fontSize: matches ? 16 : "",
                            }}
                          >
                            {i.Destination.ArrTime.substr(11, 5)}
                          </TitleText>
                          </Box>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={3}
                          lg={3}
                          style={{ textAlign: "center" }}
                        >
                          <img
                          src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
                          width="50px"
                          height="25px"
                          ></img>
                          <p>{`${i.Airline.AirlineName} (${i.Airline.AirlineCode}-${i.Airline.FlightNumber})`}</p>
                        </Grid>
                        </Grid>
                        {/* <Grid container>
                        <Grid item xs={12} sm={9} lg={9}>
                          <Box
                          display="flex"
                          justifyContent="space-between"
                          >
                          <Box>
                            <TitleText
                            textStyle={{
                              fontFamily: "unset",
                              fontWeight: 500,
                              fontSize: 18,
                            }}
                            >
                            {i.Origin.Airport.CityName}(
                            {i.Origin.Airport.AirportCode})
                            </TitleText>
                            <BodyText
                            four
                            textStyle={{
                              fontFamily: "unset",
                              fontWeight: 500,
                            }}
                            >
                            {i.Origin.Airport.AirportName}
                            </BodyText>
                          </Box>
                          <Box>
                            <TitleText
                            four
                            textStyle={{
                              fontFamily: "unset",
                              fontWeight: 500,
                            }}
                            >
                            {i.Origin.DepTime.substr(11, 5)}
                            </TitleText>
                          </Box>
                          </Box>
                          <Grid container alignItems="center">
                          <Grid item xs={6} lg={9}>
                            <Divider />
                          </Grid>
                          <Grid item xs={4} lg={3}>
                            <Box
                            style={{
                              padding: "2px 20px",
                              background: "rgb(239, 51, 57)",
                              color: "white",
                              borderRadius: 5,
                            }}
                            >
                            <BodyText three>
                              {timeConvert(i.Duration)}
                            </BodyText>
                            </Box>
                          </Grid>
                          </Grid>
                  
                          <Box
                          display="flex"
                          justifyContent="space-between"
                          >
                          <Box>
                            <TitleText
                            textStyle={{
                              fontFamily: "unset",
                              fontWeight: 500,
                              fontSize: 18,
                            }}
                            >
                            {i.Destination.Airport.CityName}(
                            {i.Destination.Airport.AirportCode})
                            </TitleText>
                            <BodyText
                            four
                            textStyle={{
                              fontFamily: "unset",
                              fontWeight: 500,
                            }}
                            >
                            {i.Destination.Airport.AirportName}
                            </BodyText>
                          </Box>
                          <Box>
                            <TitleText
                            four
                            textStyle={{
                              fontFamily: "unset",
                              fontWeight: 500,
                            }}
                            >
                            {i.Destination.ArrTime.substr(11, 5)}
                            </TitleText>
                          </Box>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={3} lg={3}>
                          <Box textAlign="center">
                          <img
                            src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
                            width="50px"
                            height="25px"
                          ></img>
                          <BodyText three>
                            {i.Airline.AirlineName}
                          </BodyText>
                          <BodyText three>
                            {i.Airline.AirlineCode}-
                            {i.Airline.FlightNumber}| Economy
                          </BodyText>
                          <BodyText three>
                            Check-In : 1Pc - 15Kgs
                          </BodyText>
                          <BodyText three>Cabin : 7Kgs</BodyText>
                          </Box>
                        </Grid>
                        </Grid> */}
                      </Box>
                      </>
                      
                    );
                  })
                : ""}
            </Box>
							
							{location.state.selectedReturn ? (
								<Box
									style={{
										padding: 15,
										background: 'white',
										color: 'gray',
										border: '1px solid #e6e6e6',
										margin: '0 0 20px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									{location.state.selectedReturn[0].Airline_Code
										? location.state.selectedReturn[0].Segments.map(
												(i, index) => {
													return <SelectedReturnEtravRow i={i} index={index} />;
												}
										  )
										: location.state.selectedReturn[0].Segments[0].map(
												(i, index) => {
													return (
														<>
															<Box
																display='flex'
																justifyContent='space-between'
																mt={index > 0 ? '20px' : ''}>
																<Box display='flex' alignItems='center'>
																	<Box alignItems='center' display='flex'>
																		<TitleText
																			textStyle={{
																				fontFamily: 'unset',
																				fontWeight: 500,
																				fontSize: 18,
																			}}>
																			{i.Origin.Airport.CityCode}
																		</TitleText>
																		-
																		<TitleText
																			textStyle={{
																				fontFamily: 'unset',
																				fontWeight: 500,
																				fontSize: 18,
																			}}>
																			{index == 0
																				? location.state.selectedReturn[0].Segments[0]
																						.filter((i, ind) => ind === 0)
																						.map((one) => {
																							return one.Destination.Airport
																								.CityCode;
																						})
																				: index == 1
																				? location.state.selectedReturn[0].Segments[0]
																						.filter((i, ind) => ind === 1)
																						.map((one) => {
																							return one.Destination.Airport
																								.CityCode;
																						})
																				: index == 2
																				? location.state.selectedReturn[0].Segments[0]
																						.filter((i, ind) => ind === 2)
																						.map((one) => {
																							return one.Destination.Airport
																								.CityCode;
																						})
																				: ''}
																		</TitleText>
																	</Box>
																	<Box
																		ml={'30px'}
																		style={{
																			background: 'rgb(239, 51, 57)',
																			padding: '3px 15px',
																			borderRadius: '50px',
																			color: 'white',
																			fontFamily: 'unset',
																			fontWeight: 500,
																		}}>
																		<TitleText two>RETURN</TitleText>
																	</Box>
																</Box>
																<Box>
																	<BodyText>Fare Rule</BodyText>
																</Box>
															</Box>
															<Box mt={'20px'}>
																<BodyText>Thursday, 10 Feb 2022</BodyText>
															</Box>
															<Box
																style={{
																	background: 'white',
																	padding: '10px 15px',
																	border: '1px solid #e6e6e6',
																	marginTop: '10px',
																	borderRadius: 5,
																}}>
																<Grid container>
																	<Grid item xs={12} sm={9} lg={9}>
																		<Box
																			display='flex'
																			justifyContent='space-between'>
																			<Box>
																				<TitleText
																					textStyle={{
																						fontFamily: 'unset',
																						fontWeight: 500,
																						fontSize: 18,
																					}}>
																					{i.Origin.Airport.CityName}(
																					{i.Origin.Airport.AirportCode})
																				</TitleText>
																				<BodyText
																					two
																					textStyle={{
																						fontFamily: 'unset',
																						fontWeight: 600,
																						fontSize: 12,
																					}}>
																					{i.Origin.Airport.AirportName}, T-3
																				</BodyText>
																			</Box>
																			<Box>
																				<TitleText
																					textStyle={{
																						fontFamily: 'unset',
																						fontWeight: 500,
																						fontSize: 18,
																					}}>
																					{i.Origin.DepTime.substr(11, 5)}
																				</TitleText>
																			</Box>
																		</Box>
																		<Grid container alignItems='center'>
																			<Grid item xs={6} lg={9}>
																				<Divider />
																			</Grid>
																			<Grid item xs={4} lg={3}>
																				<Box
																					style={{
																						padding: '2px 20px',
																						background: 'rgb(239, 51, 57)',
																						color: 'white',
																						borderRadius: 15,
																					}}>
																					<BodyText three>
																						{timeConvert(i.Duration)}
																					</BodyText>
																				</Box>
																			</Grid>
																		</Grid>

																		<Box
																			display='flex'
																			justifyContent='space-between'>
																			<Box>
																				<TitleText
																					textStyle={{
																						fontFamily: 'unset',
																						fontWeight: 500,
																						fontSize: 18,
																					}}>
																					{i.Destination.Airport.CityName}(
																					{i.Destination.Airport.AirportCode})
																				</TitleText>
																				<BodyText
																					two
																					textStyle={{
																						fontFamily: 'unset',
																						fontWeight: 600,
																						fontSize: 12,
																					}}>
																					{i.Destination.Airport.AirportName},
																					T-3
																				</BodyText>
																			</Box>
																			<Box>
																				<TitleText
																					textStyle={{
																						fontFamily: 'unset',
																						fontWeight: 500,
																						fontSize: 12,
																					}}>
																					{i.Destination.ArrTime.substr(11, 5)}
																				</TitleText>
																			</Box>
																		</Box>
																	</Grid>
																	<Grid item xs={12} sm={3} lg={3}>
																		<Box textAlign='center'>
																			{/* <img
																				width='50px'
																				height='25px'
																				src={
																					i.Airline.AirlineName == 'SpiceJet'
																						? spice
																						: i.Airline.AirlineName == 'Indigo'
																						? indigo
																						: i.Airline.AirlineName ==
																						  'GO FIRST'
																						? go_first
																						: i.Airline.AirlineName ==
																						  'Air India'
																						? air
																						: i.Airline.AirlineName ==
																						  'Air Asia'
																						? airasia
																						: i.Airline.AirlineName == 'Vistara'
																						? vistara
																						: ''
																				}></img> */}
																			<BodyText three>
																				{i.Airline.AirlineName}
																			</BodyText>
																			<BodyText three>
																				{i.Airline.AirlineCode}-
																				{i.Airline.FlightNumber}| Economy
																			</BodyText>
																			<BodyText three>
																				Check-In : 1Pc - 15Kgs
																			</BodyText>
																			<BodyText three>Cabin : 7Kgs</BodyText>
																		</Box>
																	</Grid>
																</Grid>
															</Box>
														</>
													);
												}
										  )}
								</Box>
							) : (
								''
							)}
							  {location.state.intFlight ? (
              <Box
                style={{
                  padding: 15,
                  background: "white",
                  color: "gray",
                  border: "1px solid #e6e6e6",
                  margin: "0 0 20px",
                  boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                  borderRadius: "5px",
                }}
              >
                {location.state.intFlight
                  ? location.state.intFlight.Segments[1].map((i,index) => {
                      return (
                        <>
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          mt={index > 0 ? "20px" : ""}
                        >
                          <Box display="flex" alignItems="center">
                          <Box alignItems="center" display="flex">
                            <TitleText
                            textStyle={{
                              fontFamily: "unset",
                              fontWeight: 500,
                              fontSize: 18,
                            }}
                            >
                            {i.Origin.Airport.CityCode}
                            </TitleText>
                            -
                            <TitleText
                            textStyle={{
                              fontFamily: "unset",
                              fontWeight: 500,
                              fontSize: 18,
                            }}
                            >
                            {i.Destination.Airport.CityCode}
                            </TitleText>
                          </Box>
                          {index===0?<Box
                            ml={"30px"}
                            style={{
                            background: "rgb(239, 51, 57)",
                            padding: "3px 15px",
                            borderRadius: "50px",
                            color: "white",
                            fontFamily: "unset",
                            fontWeight: 500,
                            }}
                          >
                            <TitleText two>RETRUN</TitleText>
                          </Box>:''}
                          </Box>
                          <Box>{/* <BodyText>Fare Rule</BodyText> */}</Box>
                        </Box>
                        <Box mt={"20px"}>
                          <BodyText three textStyle={{ fontSize: 16 }}>
                          {" "}
                          {`${new Date(
                            location.state.returnBody.Segments[0].PreferredDepartureTime
                          ).toLocaleString("en-us", {
                            weekday: "short",
                          })} ,  ${new Date(
                            location.state.returnBody.Segments[0].PreferredDepartureTime
                          ).getDate()} ${new Date(
                            location.state.returnBody.Segments[0].PreferredDepartureTime
                          ).toLocaleString("en-us", {
                            month: "short",
                          })},2022`}
                          </BodyText>
                        </Box>
                        <Box
                          style={{
                          background: "white",
                          padding: "10px 15px",
                          border: "1px solid #e6e6e6",
                          marginTop: "10px",
                          borderRadius: 5,
                          }}
                        >
                          <Grid container style={{ alignItems: "center" }}>
                          <Grid item xs={12} sm={3} lg={3}>
                            <Box
                            display={matches ? "flex" : ""}
                            justifyContent={
                              matches ? "space-between" : ""
                            }
                            alignItems={matches ? "center" : ""}
                            >
                            <TitleText
                              textStyle={{
                              fontFamily: "unset",
                              fontWeight: 500,
                              fontSize: 18,
                              }}
                            >
                              {i.Origin.Airport.CityName}
                              {/* {i.Origin.Airport.AirportCode}) */}
                            </TitleText>
                            <TitleText
                              three
                              textStyle={{
                              fontFamily: "unset",
                              fontWeight: 600,
                              fontSize: matches ? 16 : "",
                              }}
                            >
                              {i.Origin.DepTime.substr(11, 5)}
                            </TitleText>
                            </Box>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={3}
                            lg={3}
                            style={{ marginTop: matches ? 10 : "" }}
                          >
                            <Box
                            style={{
                              padding: "2px 20px",
                              background: "rgb(239, 51, 57)",
                              color: "white",
                              borderRadius: 25,
                            }}
                            >
                            <BodyText
                              three
                              textStyle={{
                              fontSize: 16,
                              textAlign: "center",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              }}
                            >
                              {timeConvert(i.Duration)}
                            </BodyText>
                            </Box>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={3}
                            lg={3}
                            style={{
                            textAlign: "center",
                            marginTop: matches ? 10 : "",
                            }}
                          >
                            <Box
                            display={matches ? "flex" : ""}
                            justifyContent={
                              matches ? "space-between" : ""
                            }
                            alignItems={matches ? "center" : ""}
                            >
                            <TitleText
                              textStyle={{
                              fontFamily: "unset",
                              fontWeight: 500,
                              fontSize: 18,
                              }}
                            >
                              {i.Destination.Airport.CityName}
                              {/* {i.Destination_City} */}
                              {/* {i.Origin.Airport.AirportCode}) */}
                            </TitleText>
                            <TitleText
                              three
                              textStyle={{
                              fontFamily: "unset",
                              fontWeight: 500,
                              fontSize: matches ? 16 : "",
                              }}
                            >
                              {i.Destination.ArrTime.substr(11, 5)}
                            </TitleText>
                            </Box>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={3}
                            lg={3}
                            style={{ textAlign: "center" }}
                          >
                            <img
                            src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
                            width="50px"
                            height="25px"
                            ></img>
                            <p>{`${i.Airline.AirlineName} (${i.Airline.AirlineCode}-${i.Airline.FlightNumber})`}</p>
                          </Grid>
                          </Grid>
                          {/* <Grid container>
                          <Grid item xs={12} sm={9} lg={9}>
                            <Box
                            display="flex"
                            justifyContent="space-between"
                            >
                            <Box>
                              <TitleText
                              textStyle={{
                                fontFamily: "unset",
                                fontWeight: 500,
                                fontSize: 18,
                              }}
                              >
                              {i.Origin.Airport.CityName}(
                              {i.Origin.Airport.AirportCode})
                              </TitleText>
                              <BodyText
                              four
                              textStyle={{
                                fontFamily: "unset",
                                fontWeight: 500,
                              }}
                              >
                              {i.Origin.Airport.AirportName}
                              </BodyText>
                            </Box>
                            <Box>
                              <TitleText
                              four
                              textStyle={{
                                fontFamily: "unset",
                                fontWeight: 500,
                              }}
                              >
                              {i.Origin.DepTime.substr(11, 5)}
                              </TitleText>
                            </Box>
                            </Box>
                            <Grid container alignItems="center">
                            <Grid item xs={6} lg={9}>
                              <Divider />
                            </Grid>
                            <Grid item xs={4} lg={3}>
                              <Box
                              style={{
                                padding: "2px 20px",
                                background: "rgb(239, 51, 57)",
                                color: "white",
                                borderRadius: 5,
                              }}
                              >
                              <BodyText three>
                                {timeConvert(i.Duration)}
                              </BodyText>
                              </Box>
                            </Grid>
                            </Grid>
                    
                            <Box
                            display="flex"
                            justifyContent="space-between"
                            >
                            <Box>
                              <TitleText
                              textStyle={{
                                fontFamily: "unset",
                                fontWeight: 500,
                                fontSize: 18,
                              }}
                              >
                              {i.Destination.Airport.CityName}(
                              {i.Destination.Airport.AirportCode})
                              </TitleText>
                              <BodyText
                              four
                              textStyle={{
                                fontFamily: "unset",
                                fontWeight: 500,
                              }}
                              >
                              {i.Destination.Airport.AirportName}
                              </BodyText>
                            </Box>
                            <Box>
                              <TitleText
                              four
                              textStyle={{
                                fontFamily: "unset",
                                fontWeight: 500,
                              }}
                              >
                              {i.Destination.ArrTime.substr(11, 5)}
                              </TitleText>
                            </Box>
                            </Box>
                          </Grid>
                          <Grid item xs={12} sm={3} lg={3}>
                            <Box textAlign="center">
                            <img
                              src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
                              width="50px"
                              height="25px"
                            ></img>
                            <BodyText three>
                              {i.Airline.AirlineName}
                            </BodyText>
                            <BodyText three>
                              {i.Airline.AirlineCode}-
                              {i.Airline.FlightNumber}| Economy
                            </BodyText>
                            <BodyText three>
                              Check-In : 1Pc - 15Kgs
                            </BodyText>
                            <BodyText three>Cabin : 7Kgs</BodyText>
                            </Box>
                          </Grid>
                          </Grid> */}
                        </Box>
                        </>
                       
                      );
                    })
                  : ""}
              </Box>
            ) : (
              ""
            )}
							<Box display='flex' alignItems='center'>
								<TitleText
									textStyle={{
										fontFamily: 'Josefin Sans, sans-serif',
										fontWeight: 500,
										fontSize: 20,
									}}>
									Contact Information{' '}
								</TitleText>
								{/* <TitleText
									textStyle={{
										marginLeft: 10,
										fontFamily: 'Josefin Sans, sans-serif',
										fontWeight: 500,
										fontSize: 20,
									}}>
									<span
										style={{
											color: 'blue',
											fontWeight: 500,
											cursor: 'pointer',
											fontSize: 20,
										}}
										// onClick={() => dispatch(toggleLoginModal(true))}
									>
										Sign in
									</span>{' '}
									to book faster and avail offers.{' '}
								</TitleText> */}
							</Box>
							{location.state.body ? (
								<FlightConfirmForm
									item={location.state.OneflightData}
									value={value}
								/>
							) : (
								<FlightConfirmReturnForm
									item={location.state.OneflightData}
									value={value}
								/>
							)}
							{/* <FlightConfirmForm
								item={location.state.OneflightData}
								value={value}
							/> */}
						</Grid>
						<Grid item xs={12} lg={4}>
							<Box style={{ position: 'sticky', top: 84 }}>
								<Box
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '15px',
										position: 'sticky',
										top: 84,
										zIndex: 1,
									}}>
									<Grid container alignItems='center'>
										<Grid item xs={4}>
											Fare Details
										</Grid>
										<Grid item xs={8}>
											<Divider style={{ background: 'black' }} />
										</Grid>
									</Grid>
									<Box
                    style={{
                      background: "rgba(57,201,187,.17)",
                      padding: "5px 10px",
                      margin: "10px 0 0",
                      borderRadius: "15px",
                    }}
                  >
                    <BodyText textStyle={{ fontSize: 13 }}>
                      AMOUNT TO BE PAID
                    </BodyText>
                    <TitleText textStyle={{ fontSize: 18 }}>
                    {location.state.returnBody
                      ? location.state.intFlight
                        ? Number(
                            Math.round(
                              location.state.intFlight.Fare.Total_Amount
                            )
                          )
                        : `₹ ${Number(
                            Number(
                              Math.round(
                                location.state.selectedonward[0].Airline_Code
                                  ? location.state.selectedonward[0].Fares
                                      .Total_Amount
                                  : location.state.selectedonward[0].Fare
                                      .Total_Amount
                              )
                            ) +
                              Number(
                                Math.round(
                                  location.state.selectedReturn[0].Airline_Code
                                    ? location.state.selectedReturn[0].Fares
                                        .Total_Amount
                                    : location.state.selectedReturn[0].Fare
                                        .Total_Amount
                                )
                              )-
                              Number(Math.round(location.state.selectedReturn[0].Airline_Code?0:location.state.selectedReturn[0].Fare.MFB_Discount))-
                              Number(Math.round(location.state.selectedonward[0].Airline_Code?0:location.state.selectedonward[0].Fare.MFB_Discount))
                          )}`
                      : location.state.OneflightData
                      ? `₹ ${Number(
                          location.state.OneflightData.Supplier === "ETR"
                            ? Math.round(
                                location.state.OneflightData.Fares.Total_Amount
                              )
                            : Math.round(
                                location.state.OneflightData.Fare.Total_Amount
                              )
                        )}`
                      : ""}
                  </TitleText>
                    <span>(inclusive of all taxes.)</span>
                  </Box>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    mt={"10px"}
                  >
                    <BodyText textStyle={{ fontSize: 13 }}>
                      Adultx
                      {location.state.body
                        ? location.state.body.AdultCount
                        : location.state.returnBody
                        ? location.state.returnBody.AdultCount
                        : ""}
                    </BodyText>
                    <TitleText textStyle={{ fontSize: 13 }}>
                    {location.state.returnBody
                      ? location.state.intFlight
                      ? Number(
                          Math.round(
                            location.state.intFlight.Fare.Basic_Amount
                          )
                        )
                      : `₹ ${Number(
                          Number(
                            Math.round(
                              location.state.selectedonward[0].Airline_Code
                                ? location.state.selectedonward[0].Fares
                                    .Basic_Amount
                                : location.state.selectedonward[0].Fare
                                    .Basic_Amount
                            )
                          ) +
                            Number(
                              Math.round(
                                location.state.selectedReturn[0].Airline_Code
                                  ? location.state.selectedReturn[0].Fares
                                      .Basic_Amount
                                  : location.state.selectedReturn[0].Fare
                                      .Basic_Amount
                              )
                            )
                        )}`
                      : location.state.OneflightData
                      ? `₹ ${Number(
                          location.state.OneflightData.Supplier === "ETR"
                            ? Math.round(
                                location.state.OneflightData.Fares.Basic_Amount
                              )
                            : Math.round(
                                location.state.OneflightData.Fare.Basic_Amount
                              )
                        )}`
                      : ""}
                    </TitleText>
                  </Box>
                  {baggage || baggageChild1 ? (
                    <Box display="flex" justifyContent="space-between">
                      <BodyText textStyle={{ fontSize: 13 }}>Add-Ons</BodyText>
                      <TitleText textStyle={{ fontSize: 13 }}>{`₹ ${
                        Number(baggage ? baggage : "") +
                        Number(baggageAdult2 ? baggageAdult2 : "") +
                        Number(baggageAdult3 ? baggageAdult3 : "") +
                        Number(baggageAdult4 ? baggageAdult4 : "") +
                        Number(baggageAdult5 ? baggageAdult5 : "") +
                        Number(baggageAdult6 ? baggageAdult6 : "") +
                        Number(baggageAdult7 ? baggageAdult7 : "") +
                        Number(baggageAdult8 ? baggageAdult8 : "") +
                        Number(baggageAdult9 ? baggageAdult9 : "") +
                        Number(baggageChild1 ? baggageChild1 : "") +
                        Number(baggageChild2 ? baggageChild2 : "") +
                        Number(baggageChild3 ? baggageChild3 : "") +
                        Number(baggageChild4 ? baggageChild4 : "") +
                        Number(baggageChild5 ? baggageChild5 : "") +
                        Number(baggageChild6 ? baggageChild6 : "") +
                        Number(baggageChild7 ? baggageChild7 : "") +
                        Number(baggageChild8 ? baggageChild8 : "") +
                        Number(baggageChild9 ? baggageChild9 : "")
                      }`}</TitleText>
                    </Box>
                  ) : (
                    ""
                  )}
				{/* <Box display="flex" justifyContent="space-between">
                    <BodyText textStyle={{ fontSize: 13 }}>
                      Meals
                    </BodyText>
                    <TitleText textStyle={{ fontSize: 13 }}>
                      ₹{" "}
                     300
                    </TitleText>
                  </Box> */}
                  <Box display="flex" justifyContent="space-between">
                    <BodyText textStyle={{ fontSize: 13 }}>
                      Total Taxes
                    </BodyText>
                    <TitleText textStyle={{ fontSize: 13 }}>
                    ₹{" "}
                    {location.state.returnBody
                      ? location.state.intFlight
                      ? Number(
                          Math.round(
                            location.state.intFlight.Fare.AirportTax_Amount
                          )
                        )
                      : ` ${Number(
                          Number(
                            Math.round(
                              location.state.selectedonward[0].Airline_Code
                                ? location.state.selectedonward[0].Fares
                                    .AirportTax_Amount
                                : location.state.selectedonward[0].Fare
                                    .AirportTax_Amount
                            )
                          ) +
                            Number(
                              Math.round(
                                location.state.selectedReturn[0].Airline_Code
                                  ? location.state.selectedReturn[0].Fares
                                      .AirportTax_Amount
                                  : location.state.selectedReturn[0].Fare
                                      .AirportTax_Amount
                              )
                            )
                        )}`
                      : location.state.OneflightData
                      ? ` ${Number(
                          location.state.OneflightData.Supplier === "ETR"
                            ? Math.round(
                                location.state.OneflightData.Fares.AirportTax_Amount
                              )
                            : Math.round(
                                location.state.OneflightData.Fare.AirportTax_Amount
                              )
                        )}`
                      : ""}
                    </TitleText>
                  </Box>
                  {/* <Divider /> */}
                  {false ? (
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      mt={"5px"}
                      mb={"5px"}
                    >
                      <BodyText>Convenience Fees</BodyText>
                      <TitleText two>₹ {location.state.OneflightData.Supplier === "TBO"
                    ? Number(Math.round(Number(Number(
                        Math.round(
                          location.state.OneflightData.Fare.Total_Amount
                        )
                      )-Number(Math.round(location.state.OneflightData.Fare.agentMarkup)))*2.5/100))
                    : Number(Math.round(Number(Number(
                        Math.round(
                          location.state.OneflightData.Fares.Total_Amount
                        )
                      )-Number(Math.round(location.state.OneflightData.Fares.agentMarkup)))*2.5/100))}</TitleText>
                    </Box>
                  ) : (
                    ""
                  )}
									<Divider />
								</Box>
								{/* <Box
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
										// position: 'sticky',
										// top: value ? 320 : 275,
										zIndex: 1,
									}}>
									<Grid container alignItems='center'>
										<Grid item xs={4}>
											Promo Code
										</Grid>
										<Grid item xs={8}>
											<Divider style={{ background: 'black' }} />
										</Grid>
									</Grid>
									<Box className={classes.radio}>
										<RadioGroup
											aria-label='gender'
											name='gender1'
											value={value}
											// onChange={handleChange}
										>
											<FormControlLabel
												value='female'
												control={<Radio onClick={handleClick} />}
												label='NOFEES'
											/>
											<span style={{ marginLeft: 10 }}>
												Use this promo ad save 200
											</span>
										</RadioGroup>
									</Box>
								</Box> */}
							</Box>
						</Grid>
					</Grid>
				{/* </Container> */}
			</Box>
			<AddGSTModal />
			<TermConditionModal />
			<Drawers />
			<Login />
			<ErrorModal />
		</>
	);
};

export default ConfirmFlight;
